// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3W3-3","notes":"Notes_notes__1fMSB","note":"Notes_note__UjmTG","markdown":"Notes_markdown__P2JFs"};